module.exports = __webpack_public_path__ + "img/shuibeiCenter.b6845b73.png";